import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { PostPricePeriodValueGroupedModel, PricePeriodValueModel } from '../pricing/model/values'
import { PricePeriodTableModel } from './model/pricePeriods'

export const apiGetPricePeriodByID = async (priceID: number): Promise<PricePeriodTableModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59923'

  return await AxiosInstance.get(`${apiSuffixUrl}/api/PricePeriods(${priceID})`).then(response => {
    return response.data
  })
}

export const apiUpdatePricePeriodValues = async (
  priceID: number,
  request: PostPricePeriodValueGroupedModel
): Promise<PricePeriodValueModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59923'

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/PricePeriods/${priceID}/PricePeriodValues`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiBulkDeletePricePeriodValues = async (
  priceID: number,
  priceValuesIds: number[]
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59923'

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/PricePeriods/${priceID}/PricePeriodValues/bulkDelete`,
    priceValuesIds
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
